import React from 'react';
export function TopBar() {
  return <div className="bg-gradient-to-r from-gold via-yellow-400 to-gold text-center py-1.5 px-4 z-40" data-id="element-122">
      <p className="text-xs font-normal text-header tracking-wide" data-id="element-123">
        Custom software development, web applications, mobile apps, AI
        automation, e-commerce platforms, database systems, and enterprise
        software integrations.
      </p>
    </div>;
}